/**
 * Check if a given object implements the UpdateOfferGroupResponse interface.
 */
export function instanceOfUpdateOfferGroupResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
export function UpdateOfferGroupResponseFromJSON(json) {
    return UpdateOfferGroupResponseFromJSONTyped(json, false);
}
export function UpdateOfferGroupResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function UpdateOfferGroupResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
